// extracted by mini-css-extract-plugin
export var textInput = "_eh-0";